class AccountEmployeesListController {
    public currentPage: number;
    public itemsPerPage: number;

    constructor() {
        'ngInject';
    }

    public $onInit = () => {
        this.currentPage = 1;
        this.itemsPerPage = 12;
    }
    
    parseDate(item) {
        var date = new Date(item.start);
        return date;
    }
}

export const accountEmployeesListComponent = {
    bindings: {
        accountEmployees: "<"
    },
    controller: AccountEmployeesListController,
    template: require('./employees.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/employees/employees.list.component.ts